import type { OperatorMapPreviewSnapshot } from './operatorMapPreview'

type OperatorMapPreviewCardProps = {
  snapshot: OperatorMapPreviewSnapshot
  onMouseEnter?: () => void
  onMouseLeave?: () => void
}

/** Lower-left hover preview while browsing the Home map operator rail. */
export function OperatorMapPreviewCard({
  snapshot,
  onMouseEnter,
  onMouseLeave,
}: OperatorMapPreviewCardProps) {
  return (
    <div
      className="asset-map-preview-card map-overlay-preview-card"
      role="region"
      aria-label={`Preview ${snapshot.name}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="map-overlay-preview-card-head">
        <p className="asset-map-preview-title">{snapshot.name}</p>
      </div>
      <div className="map-overlay-preview-card-body">
        {snapshot.fields.length > 0 ? (
          <dl className="operator-map-preview-fields">
            {snapshot.fields.map((field) => (
              <div key={field.label} className="operator-map-preview-field">
                <dt className="operator-map-preview-field-label">{field.label}</dt>
                <dd className="operator-map-preview-field-value">{field.value}</dd>
              </div>
            ))}
          </dl>
        ) : (
          <p className="asset-map-preview-muted">No preview details loaded for this operator yet.</p>
        )}
      </div>
    </div>
  )
}
